import React from "react";
import ReactDOM from "react-dom";
import { Modal, FormGroup, FormControl } from "react-bootstrap";
import ListActions from "ListActions";
import KeyCodes from "KeyCodes";
import BaseServiceApi from 'BaseServiceApi';
import LocalizationStore from "../../Stores/Localization/LocalizationStore.js";

let ListType = BaseServiceApi.rayData["ListType"];

export default class RenameColumnSet extends React.Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.title = 'RENAME COLUMN SET';
    this.columnSet = null;
    this.state = {
      value: ''
    }
    this.textLimit = 35;
  }

  componentDidMount() {
    this.columnSet = JSON.parse(this.props.columnSet);
    if (this.columnSet.listType == ListType.FOLDER_List) this.title = LocalizationStore.getTranslatedData("LM_TP_RenameColSet", "RENAME COLUMN SET") + LocalizationStore.getTranslatedData("LM_TP_Folder_1", " Folder");
    else this.title = LocalizationStore.getTranslatedData("LM_TP_RenameColSet", "RENAME COLUMN SET");

    this.setState({ value: this.columnSet.name });

    let self = this;
    window.setTimeout(() => {
      ReactDOM.findDOMNode(self.nameRef).select();
    }, 0);
  }

  handleChange(e) {
    let saveButtonClasses = this.seveColSet.classList;
    if (e.target.value.split(' ').join('') == '')
      saveButtonClasses.add("nohover");
    else
      saveButtonClasses.remove("nohover");

    this.setState({ value: e.target.value });
  }

  handleKeyPress(e) {
    let charCode = (e.which) ? e.which : e.keyCode;
    if (charCode == KeyCodes.ENTER) {
      this.handleSave();
    }
  }

  handleSave() {
    let newColSetName = ReactDOM.findDOMNode(this.nameRef).value;
    //newColSetName = StringUtil.stripHTML(newColSetName);
    if (newColSetName.split(' ').join('') != '') {
      if (this.columnSet.listType == ListType.FOLDER_List)
        ListActions.addRenameColumnSetFolder(newColSetName, 0, this.columnSet.columnSetId);
      else
        ListActions.renameColumnSet(newColSetName, this.columnSet.columnSetId);
    }
  }

  render() {
    return (
      <div>
        <Modal className="modal-popup column-sets rename-column-set" show={this.props.showModal}>
          <Modal.Header>
            <Modal.Title className="cap-header">{this.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-material">
              <h6>{LocalizationStore.getTranslatedData("LM_TP_EnterAName", "Enter a name")}</h6>
              <FormGroup bsSize="small">
                <FormControl type="text" inputRef={(ref) => this.nameRef = ref} value={this.state.value} onChange={this.handleChange} onKeyPress={this.handleKeyPress} maxLength={this.textLimit} />
              </FormGroup>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span className="btn-box">
              <button type="button" className="btn btn-xs btn-default btn-secondary" onClick={this.props.closeModal}>{LocalizationStore.getTranslatedData("tp_pt_cancel", "Cancel")}</button>
              <button type="button" className="btn btn-xs btn-default btn-secondary" ref={(button) => { this.seveColSet = button }} id="saveColSet" onClick={this.handleSave}>{LocalizationStore.getTranslatedData("save", "Save")}</button>
            </span>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}